import Header from '../partials/common/header/header';
import Footer from '../partials/common/footer/footer';
import Packages from "../partials/home/packages";

function Tours() {
    return (
        <>
            <Header/>
            <Packages/>
            <Footer/>
        </>
    );
}

export default Tours;